import React from "react";

// --- Language SVG Icons ---

export const JavaIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 256 346" xmlns="http://www.w3.org/2000/svg">
        <path d="M82.554 267.473s-13.198 7.675 9.393 10.272c27.369 3.122 41.356 2.675 71.517-3.034 0 0 7.93 4.972 19.003 9.279-67.611 28.977-153.019-1.679-99.913-16.517M74.292 229.659s-14.803 10.958 7.805 13.296c29.236 3.016 52.324 3.263 92.276-4.43 0 0 5.526 5.602 14.215 8.666-81.747 23.904-172.842 1.885-114.296-17.532" fill="#5382A1"/>
        <path d="M143.942 165.515c16.66 19.18-4.377 36.44-4.377 36.44s42.301-21.837 22.874-49.183c-18.144-25.5-32.059-38.172 43.268-81.858 0 0-118.238 29.53-61.765 94.6" fill="#E76F00"/>
        <path d="M233.364 295.442s9.767 8.047-10.757 14.273c-39.026 11.823-162.432 15.393-196.714.471-12.323-5.36 10.787-12.8 18.056-14.362 7.581-1.644 11.914-1.337 11.914-1.337-13.705-9.655-88.583 18.957-38.034 27.15 137.853 22.356 251.292-10.066 215.535-26.195M88.9 190.48s-62.771 14.91-22.228 20.323c17.118 2.292 51.243 1.774 83.03-.89 25.978-2.19 52.063-6.85 52.063-6.85s-9.16 3.923-15.787 8.448c-63.744 16.765-186.886 8.966-151.435-8.183 29.981-14.492 54.358-12.848 54.358-12.848M201.506 253.422c64.8-33.672 34.839-66.03 13.927-61.67-5.126 1.066-7.411 1.99-7.411 1.99s1.903-3.338 5.53-4.781c41.328-14.54 73.123 42.897-13.36 65.647 0 0 .996-.895 1.314-1.186" fill="#5382A1"/>
        <path d="M162.439.371s35.887 35.9-34.037 91.101c-56.071 44.282-12.786 69.53-.023 98.377-32.73-29.53-56.75-55.526-40.635-79.72C111.395 74.612 176.918 57.393 162.439.37" fill="#E76F00"/>
        <path d="M95.268 344.665c62.199 3.982 157.712-2.209 159.974-31.64 0 0-4.348 11.158-51.404 20.018-53.088 9.99-118.564 8.824-157.399 2.421 0 0 7.95 6.58 48.83 9.201" fill="#5382A1"/>
    </svg>
);

export const PythonIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 256 255" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="py-a" x1="12.959%" x2="79.639%" y1="12.039%" y2="78.201%">
                <stop offset="0%" stopColor="#387EB8"/>
                <stop offset="100%" stopColor="#366994"/>
            </linearGradient>
            <linearGradient id="py-b" x1="19.128%" x2="90.742%" y1="20.579%" y2="88.429%">
                <stop offset="0%" stopColor="#FFE052"/>
                <stop offset="100%" stopColor="#FFC331"/>
            </linearGradient>
        </defs>
        <path d="M126.916.072c-64.832 0-60.784 28.115-60.784 28.115l.072 29.128h61.868v8.745H41.631S.145 61.355.145 126.77c0 65.417 36.21 63.097 36.21 63.097h21.61v-30.356s-1.165-36.21 35.632-36.21h61.362s34.475.557 34.475-33.319V33.97S194.67.072 126.916.072zM92.802 19.66a11.12 11.12 0 0 1 11.13 11.13 11.12 11.12 0 0 1-11.13 11.13 11.12 11.12 0 0 1-11.13-11.13 11.12 11.12 0 0 1 11.13-11.13z" fill="url(#py-a)"/>
        <path d="M128.757 254.126c64.832 0 60.784-28.115 60.784-28.115l-.072-29.127H127.6v-8.745h86.441s41.486 4.705 41.486-60.712c0-65.416-36.21-63.096-36.21-63.096h-21.61v30.355s1.165 36.21-35.632 36.21h-61.362s-34.475-.557-34.475 33.32v56.013s-5.235 33.897 62.518 33.897zm34.114-19.586a11.12 11.12 0 0 1-11.13-11.13 11.12 11.12 0 0 1 11.13-11.131 11.12 11.12 0 0 1 11.13 11.13 11.12 11.12 0 0 1-11.13 11.13z" fill="url(#py-b)"/>
    </svg>
);

export const NodeJsIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 256 289" xmlns="http://www.w3.org/2000/svg">
        <path d="M128 288.464c-3.975 0-7.685-1.06-11.13-2.915l-35.247-20.936c-5.3-2.915-2.65-3.975-1.06-4.505 7.155-2.385 8.48-2.915 15.9-7.155.796-.53 1.856-.265 2.65.265l27.032 16.166c1.06.53 2.385.53 3.18 0l105.74-61.217c1.06-.53 1.59-1.59 1.59-2.915V83.08c0-1.325-.53-2.385-1.59-2.915L129.325 19.213c-1.06-.53-2.385-.53-3.18 0L20.404 80.165c-1.06.53-1.59 1.855-1.59 2.915v122.17c0 1.06.53 2.385 1.59 2.915l28.887 16.695c15.636 7.95 25.44-1.325 25.44-10.6V93.68c0-1.59 1.325-3.18 3.18-3.18h13.516c1.59 0 3.18 1.325 3.18 3.18v120.58c0 20.936-11.396 33.126-31.272 33.126-6.095 0-10.865 0-24.38-6.625l-27.828-15.9C4.24 220.885 0 213.996 0 206.576V84.14c0-7.42 4.24-14.31 11.13-18.02L116.87 4.903c6.625-3.71 15.636-3.71 22.26 0L244.87 66.12c6.89 3.71 11.13 10.6 11.13 18.02v122.17c0 7.42-4.24 14.31-11.13 18.02L139.13 285.55c-3.445 1.855-7.42 2.915-11.13 2.915" fill="#539E43"/>
        <path d="M159.903 204.456c-63.6 0-76.851-29.152-76.851-53.798 0-1.59 1.325-3.18 3.18-3.18h13.78c1.59 0 2.916 1.06 2.916 2.65 2.12 14.31 8.215 21.465 36.307 21.465 22.26 0 31.802-5.035 31.802-16.96 0-6.89-2.65-11.925-37.367-15.37-28.887-2.915-46.913-9.275-46.913-32.33 0-21.466 18.02-34.187 48.238-34.187 33.921 0 50.617 11.66 52.737 37.102 0 .795-.265 1.59-.795 2.385-.53.53-1.325 1.06-2.12 1.06h-13.78c-1.325 0-2.65-1.06-2.916-2.385-3.18-14.575-11.395-19.345-33.126-19.345-24.38 0-27.296 8.48-27.296 14.84 0 7.685 3.445 10.07 36.307 14.31 32.597 4.24 47.968 10.335 47.968 33.126-.265 23.321-19.345 36.572-53.002 36.572" fill="#539E43"/>
    </svg>
);

// --- Code Samples ---

export interface EncryptionCodeSample {
    label: string;
    language: string;
    icon: React.ReactElement;
    encrypt: { title: string; code: string };
    decrypt: { title: string; code: string };
}

export const ENCRYPTION_CODE_SAMPLES: EncryptionCodeSample[] = [
    {
        label: 'Java',
        language: 'java',
        icon: <JavaIcon />,
        encrypt: {
            title: 'Encrypt Request',
            code: `import javax.crypto.Cipher;
import javax.crypto.spec.GCMParameterSpec;
import javax.crypto.spec.SecretKeySpec;
import java.nio.ByteBuffer;
import java.nio.charset.StandardCharsets;
import java.security.SecureRandom;
import java.util.Base64;

// Your 256-bit key (from onboarding)
byte[] keyBytes = Base64.getDecoder()
    .decode("<YOUR_BASE64_KEY>");

// 1. Serialize request to JSON
String requestJson = "{\\"id\\":\\"123\\"}";
byte[] plaintext = requestJson
    .getBytes(StandardCharsets.UTF_8);

// 2. Generate random 12-byte nonce
byte[] nonce = new byte[12];
new SecureRandom().nextBytes(nonce);

// 3. Encrypt with AES-256-GCM
SecretKeySpec keySpec =
    new SecretKeySpec(keyBytes, "AES");
Cipher cipher =
    Cipher.getInstance("AES/GCM/NoPadding");
GCMParameterSpec gcmSpec =
    new GCMParameterSpec(128, nonce);
cipher.init(Cipher.ENCRYPT_MODE, keySpec, gcmSpec);
byte[] ciphertextWithTag =
    cipher.doFinal(plaintext);

// 4. Build payload: nonce || ciphertext || tag
ByteBuffer buffer = ByteBuffer
    .allocate(12 + ciphertextWithTag.length);
buffer.put(nonce);
buffer.put(ciphertextWithTag);

// 5. Wrap in envelope
String envelope = String.format(
    "{\\"payload\\":\\"%s\\",\\"v\\":1}",
    Base64.getEncoder()
        .encodeToString(buffer.array())
);

// 6. Send 'envelope' as the request body`,
        },
        decrypt: {
            title: 'Decrypt Response',
            code: `import com.fasterxml.jackson.databind.*;
import java.util.Arrays;

ObjectMapper mapper = new ObjectMapper();

// 1. Parse response envelope
JsonNode envelope =
    mapper.readTree(responseBody);
String payloadBase64 =
    envelope.get("payload").asText();
byte[] payload = Base64.getDecoder()
    .decode(payloadBase64);

// 2. Extract nonce and ciphertext+tag
byte[] nonce =
    Arrays.copyOfRange(payload, 0, 12);
byte[] ciphertextWithTag =
    Arrays.copyOfRange(payload, 12,
        payload.length);

// 3. Decrypt
SecretKeySpec keySpec =
    new SecretKeySpec(keyBytes, "AES");
Cipher cipher =
    Cipher.getInstance("AES/GCM/NoPadding");
GCMParameterSpec gcmSpec =
    new GCMParameterSpec(128, nonce);
cipher.init(Cipher.DECRYPT_MODE,
    keySpec, gcmSpec);
byte[] plaintext =
    cipher.doFinal(ciphertextWithTag);

// 4. Parse decrypted JSON
String responseJson =
    new String(plaintext,
        StandardCharsets.UTF_8);`,
        },
    },
    {
        label: 'Python',
        language: 'python',
        icon: <PythonIcon />,
        encrypt: {
            title: 'Encrypt Request',
            code: `import json, base64, os
from cryptography.hazmat.primitives\\
    .ciphers.aead import AESGCM

# Initialize with your 256-bit key
key = base64.b64decode("<YOUR_BASE64_KEY>")
aesgcm = AESGCM(key)

def encrypt_request(plaintext_json: str) -> str:
    """Encrypt a JSON string for
    sending to Risk Gauge."""
    nonce = os.urandom(12)  # 96-bit nonce
    plaintext = plaintext_json.encode("utf-8")
    ciphertext_with_tag = aesgcm.encrypt(
        nonce, plaintext, None
    )
    payload = nonce + ciphertext_with_tag
    envelope = {
        "payload": base64.b64encode(payload)
            .decode("utf-8"),
        "v": 1
    }
    return json.dumps(envelope)`,
        },
        decrypt: {
            title: 'Decrypt Response',
            code: `def decrypt_response(
    response_body: str
) -> dict:
    """Decrypt a Risk Gauge
    response envelope."""
    envelope = json.loads(response_body)
    payload = base64.b64decode(
        envelope["payload"]
    )
    nonce = payload[:12]
    ciphertext_with_tag = payload[12:]
    plaintext = aesgcm.decrypt(
        nonce, ciphertext_with_tag, None
    )
    return json.loads(
        plaintext.decode("utf-8")
    )`,
        },
    },
    {
        label: 'Node.js',
        language: 'javascript',
        icon: <NodeJsIcon />,
        encrypt: {
            title: 'Encrypt Request',
            code: `const crypto = require('crypto');

const key = Buffer.from(
  '<YOUR_BASE64_KEY>', 'base64'
);

function encryptRequest(plaintextJson) {
  const nonce = crypto.randomBytes(12);
  const cipher = crypto.createCipheriv(
    'aes-256-gcm', key, nonce
  );

  let ciphertext = cipher.update(
    plaintextJson, 'utf8'
  );
  ciphertext = Buffer.concat([
    ciphertext, cipher.final()
  ]);
  const tag = cipher.getAuthTag();

  const payload = Buffer.concat([
    nonce, ciphertext, tag
  ]);
  return JSON.stringify({
    payload: payload.toString('base64'),
    v: 1
  });
}`,
        },
        decrypt: {
            title: 'Decrypt Response',
            code: `function decryptResponse(responseBody) {
  const envelope = JSON.parse(responseBody);
  const payload = Buffer.from(
    envelope.payload, 'base64'
  );

  const nonce = payload.slice(0, 12);
  const ciphertext = payload.slice(12, -16);
  const tag = payload.slice(-16);

  const decipher = crypto.createDecipheriv(
    'aes-256-gcm', key, nonce
  );
  decipher.setAuthTag(tag);

  let plaintext = decipher.update(ciphertext);
  plaintext = Buffer.concat([
    plaintext, decipher.final()
  ]);
  return JSON.parse(
    plaintext.toString('utf8')
  );
}`,
        },
    },
];
